import { UrlCards, UrlCategory } from '../../Url'

export default {
    namespaced: true,

    state: {
        card: [],
        category: [],
        loadingStatus: false,
        validatorCards: false,
    },
    mutations: {
        showcards(state, apiValueCard) {
            state.card = apiValueCard
        },
        showcategories(state, apiValueCategory) {
            state.category = apiValueCategory
        },
        resetCards(state) {
            ;(state.card = []), (state.category = [])
        },
        loadingStatus(state, newLoadingStatus) {
            state.loadingStatus = newLoadingStatus
        },
        validatorCards(state, change) {
            state.validatorCards = change
        },
    },
    actions: {
        apiCards: async ({ commit }, param) => {
            commit('loadingStatus', true)
            const resCard = await fetch(UrlCards)
            const resCategories = await fetch(UrlCategory)
            const dataCard = await resCard.json()
            const dataCategories = await resCategories.json()

            let cardsCategory = dataCard.data.filter(
                (cate) => cate.category_id === param
            )
            let pickCategory = dataCategories.data.filter(
                (cate) => cate.id === param
            )
            commit('showcards', cardsCategory)
            commit('showcategories', pickCategory)
            commit('validatorCards', true)
            commit('loadingStatus', false)
        },

        resetCards: function (context) {
            context.commit('resetCards')
            context.commit('validatorCards', false)
        },
    },
    getters: {},
}
